import { useEffect, useState } from 'react';
import { usePrebid } from './usePrebid';

interface UseAdUnitReturn {
  isLoaded: boolean;
  isRendered: boolean;
  refresh: () => void;
}

export const useAdUnit = (code: string): UseAdUnitReturn => {
  const { pbjs } = usePrebid();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    if (!pbjs) return;

    const handleBidResponse = () => {
      setIsLoaded(true);
    };

    const handleAdRender = () => {
      setIsRendered(true);
    };

    pbjs.onEvent('bidResponse', handleBidResponse, code);
    pbjs.onEvent('adRender', handleAdRender, code);

    return () => {
      pbjs.offEvent('bidResponse', handleBidResponse, code);
      pbjs.offEvent('adRender', handleAdRender, code);
    };
  }, [code, pbjs]);

  const refresh = () => {
    if (pbjs) {
      pbjs.requestBids({
        adUnitCodes: [code],
        bidsBackHandler: () => {
          window.googletag.pubads().refresh([code]);
        }
      });
    }
  };

  return {
    isLoaded,
    isRendered,
    refresh
  };
}; 